/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/no-empty-function */
import { User } from 'oidc-client';
import React, { Component } from 'react';

import { AuthServiceSingleton } from './authServices';

export type AuthContextType = {
  signinRedirectCallback: () => void;
  logout: () => void;
  signoutRedirectCallback: () => void;
  isAuthenticated: () => boolean;
  signinRedirect: () => void;
  signinSilentCallback: () => void;
  createSigninRequest: () => void;
  user: User | null;
  getUser: () => void;
};

export const AuthContext: React.Context<AuthContextType> =
  React.createContext<AuthContextType>({
    signinRedirectCallback: () => {},
    logout: () => {},
    signoutRedirectCallback: () => {},
    isAuthenticated: () => false,
    signinRedirect: () => {},
    signinSilentCallback: () => {},
    createSigninRequest: () => {},
    getUser: () => {},
    user: null,
  });

export const AuthConsumer = AuthContext.Consumer;

export class AuthProvider extends Component {
  authService: any;
  constructor(props: any) {
    super(props);
    this.authService = AuthServiceSingleton.getInstance();
  }
  render() {
    return (
      <AuthContext.Provider value={this.authService}>
        {this.props.children}
      </AuthContext.Provider>
    );
  }
}
